/** 搜列每页商品数（首屏请求、分页、Redux 默认值保持一致） */
export const SEARCH_LIST_PAGE_SIZE = 30;

/**
 * 搜列价格滑块/输入默认上限（WIMP `S_searchPriceMax` 未配置或非法时回落）。
 * TRD：Key=`S_searchPriceMax`，应用范围前端；各国差异走国家默认值。
 */
export const SEARCH_PRICE_MAX_DEFAULT = 250000;

/** 解析 WIMP /settings/auth 下发的搜索价格上限，非法则回落默认值 */
export function resolveSearchPriceMax(raw: unknown): number {
  const n = Number(raw);
  if (Number.isFinite(n) && n > 0) {
    return Math.floor(n);
  }
  return SEARCH_PRICE_MAX_DEFAULT;
}

/** 统一解析 URL / Redux 中的 brandRole（垂搜 brand_code 或 GMS brandId 字符串） */
export function normalizeBrandRole(raw: unknown): string[] {
  if (!raw) {
    return [];
  }
  if (Array.isArray(raw)) {
    return raw.map(String).filter(Boolean);
  }
  if (typeof raw === 'string') {
    return raw
      .split(',')
      .map(item => item.trim())
      .filter(Boolean);
  }
  return [];
}
